// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function totalPages(totalRecords, perPage) {
  if (perPage <= 0 || totalRecords <= 0) {
    return 1;
  } else {
    return Caml_int32.div(totalRecords - 1 | 0, perPage) + 1 | 0;
  }
}

function parseHeaderValue(value, $$default) {
  if (value !== undefined) {
    return Caml_option.valFromOption(value);
  } else {
    return $$default;
  }
}

function fromFetchHeaders(headers) {
  return {
          total: parseHeaderValue(Caml_option.null_to_opt(headers.get("Total")), "0"),
          perPage: parseHeaderValue(Caml_option.null_to_opt(headers.get("Per-Page")), "20")
        };
}

var emptyPageInfo = {
  total: "0",
  perPage: "20"
};

exports.emptyPageInfo = emptyPageInfo;
exports.totalPages = totalPages;
exports.parseHeaderValue = parseHeaderValue;
exports.fromFetchHeaders = fromFetchHeaders;
/* No side effect */
